export default "__VITE_ASSET__CIRgAFy6__"